export default __webpack_public_path__ + "static/media/groupIcon.5f26342c.svg";